export default {
    defaultsCodes: [
        {
            code: "thirds",
            label: window.i18n.__("Code comptable Client"),
            type: "third",
        },
        {
            code: "staffs",
            label: window.i18n.__("Code comptable Staff"),
            type: "third",
        },
        {
            code: "suppliers",
            label: window.i18n.__("Code comptable Fournisseur"),
            type: "third",
        },
        {
            code: "banks",
            label: window.i18n.__("Code comptable Banque par défaut"),
            type: "bank",
        },
        {
            code: "pay_mediums",
            label: window.i18n.__("Code comptable par défaut des moyens de paiement"),
            type: "bank",
        },
        {
            code: "products_sales",
            label: window.i18n.__("Code comptable de vente par défaut (produits)"),
            type: "sell",
        },
        {
            code: "services_sales",
            label: window.i18n.__("Code comptable de vente par défaut (services)"),
            type: "sell",
        },
        {
            code: "products_purchases",
            label: window.i18n.__("Code comptable d’achat par défaut (produits)"),
            type: "purchase",
        },
        {
            code: "services_purchases",
            label: window.i18n.__("Code comptable d’achat par défaut (services)"),
            type: "purchase",
        },
    ],
    collected_vat: [
        {
            code: "collected_vat",
            label: window.i18n.__("Code comptable TVA collectée"),
            type: "debitVat",
        },
        {
            code: "collected_vat",
            label: window.i18n.__("Code comptable TVA sur les encaissements"),
            type: "collectionVat",
        },
    ],
    deductible_vat: [
        {
            code: "deductible_vat",
            label: window.i18n.__("Code comptable TVA déductible"),
            type: "debitVat",
        },
        {
            code: "deductible_vat",
            label: window.i18n.__("Code comptable TVA sur les décaissements"),
            type: "collectionVat",
        },
    ],
    discount: [
        {
            code: "sell_discount_code_id",
            label: window.i18n.__("Code comptable pour les remises de vente"),
            type: "sell",
        },
        {
            code: "purchase_discount_code_id",
            label: window.i18n.__("Code comptable pour les remises d'achat"),
            type: "purchase",
        },
    ],
    commissions: [
        {
            code: "commissions",
            label: window.i18n.__("Code comptable pour les commissions"),
            type: "reconciliation",
        },
    ],
};
